"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSizes = exports["default"] = exports.StatusVariants = exports.SizeVariants = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("../../components/Box"));
var _theme = _interopRequireDefault(require("../../theme"));
var _AlertCheckmark = _interopRequireDefault(require("../AlertCheckmark"));
var _AlertError = _interopRequireDefault(require("../AlertError"));
var _AlertInfo = _interopRequireDefault(require("../AlertInfo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StatusVariants = exports.StatusVariants = /*#__PURE__*/function (StatusVariants) {
  StatusVariants["ok"] = "ok";
  StatusVariants["information"] = "information";
  StatusVariants["take note"] = "take note";
  StatusVariants["alert"] = "alert";
  return StatusVariants;
}({});
var SizeVariants = exports.SizeVariants = /*#__PURE__*/function (SizeVariants) {
  SizeVariants["small"] = "small";
  SizeVariants["medium"] = "medium";
  SizeVariants["large"] = "large";
  return SizeVariants;
}({});
var getSizes = exports.getSizes = function getSizes(size) {
  switch (size) {
    case SizeVariants.small:
      return {
        boxSize: 32,
        iconSize: 16
      };
    default:
    case SizeVariants.medium:
      return {
        boxSize: 40,
        iconSize: 20
      };
    case SizeVariants.large:
      return {
        boxSize: 48,
        iconSize: 24
      };
  }
};
var AlertIconBadge = function AlertIconBadge(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'information' : _ref$variant;
  var _getSizes = getSizes(size),
    boxSize = _getSizes.boxSize,
    iconSize = _getSizes.iconSize;
  var _ref2 = function () {
      switch (variant) {
        case StatusVariants.ok:
          return {
            icon: /*#__PURE__*/_react["default"].createElement(_AlertCheckmark["default"], {
              size: iconSize,
              color: "black"
            }),
            bgColor: _theme["default"].alertSuccess100,
            ariaLabel: StatusVariants.ok
          };
        case StatusVariants['take note']:
          return {
            icon: /*#__PURE__*/_react["default"].createElement(_AlertError["default"], {
              size: iconSize,
              color: "black"
            }),
            bgColor: _theme["default"].alertWarning100,
            ariaLabel: StatusVariants['take note']
          };
        case StatusVariants.alert:
          return {
            icon: /*#__PURE__*/_react["default"].createElement(_AlertError["default"], {
              size: iconSize,
              color: "black"
            }),
            bgColor: _theme["default"].alertError100,
            ariaLabel: StatusVariants.alert
          };
        case StatusVariants.information:
        default:
          return {
            icon: /*#__PURE__*/_react["default"].createElement(_AlertInfo["default"], {
              size: iconSize,
              color: "black"
            }),
            bgColor: _theme["default"].alertInfo100,
            ariaLabel: StatusVariants.information
          };
      }
    }(),
    icon = _ref2.icon,
    bgColor = _ref2.bgColor,
    ariaLabel = _ref2.ariaLabel;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    size: boxSize,
    borderRadius: _theme["default"].radii.borderRadius10,
    bg: bgColor,
    "aria-label": ariaLabel,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, icon);
};
AlertIconBadge.propTypes = {
  size: _propTypes["default"].any,
  variant: _propTypes["default"].any
};
var _default = exports["default"] = AlertIconBadge;